export default __webpack_public_path__ + "static/media/frame1a.18a1ae00.PNG";